module.exports = __webpack_public_path__ + "media/images/arrow_right-a9a7f5974442c97a5dbbbb40d11ae14b.png";